<template>
  <ul class="card link-list"><!-- add-on-links -->
    <li v-if="canChangeSeat" class="link-list__item">
      <router-link
        class="link-list__link"
        :to="{
          name: 'AfterSaleSeats',
          params: { bookingNumber }
        }"
      >
        <span>
          <div class="link-list__icon-square">
            <svg class="link-list__icon-link">
              <use :xlink:href="`#${seatBox}`" />
            </svg>
          </div>
          {{ $t('afterSale.addons.addSeat') }}
        </span>
        <svg class="link-list__chevron">
          <use :xlink:href="`#${chevron}`" />
        </svg>
      </router-link>
    </li>
    <li class="link-list__item">
      <router-link
        class="link-list__link"
        :to="{
          name: 'AfterSaleEquipment',
          params: { bookingNumber }
        }"
      >
        <span>
          <div class="link-list__icon-square">
            <svg class="link-list__icon-link">
              <use :xlink:href="`#${bikeBox}`" />
            </svg>
          </div>
          {{ $t('afterSale.addons.selectAddons') }}
        </span>
        <svg class="link-list__chevron">
          <use :xlink:href="`#${chevron}`" />
        </svg>
      </router-link>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import seatBox from '@/assets/icons/seatBox.svg'
import bikeBox from '@/assets/icons/bikeBox.svg'
import chevron from '@/assets/icons/chevron.svg'

interface BookingData {
  outbound_booking_tariff_segments: Array<{
    required_products: Array<{
      can_change_seat: boolean;
    }>;
  }>;
  booking_number: string;
}

export default defineComponent({
  name: 'AddOnLinks',
  props: {
    bookingData: {
      type: Object as PropType<BookingData>,
      required: false,
      default: null
    },
    bookingNumber: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { t } = useI18n()
    const canChangeSeat = computed(() => {
      if (!props.bookingData?.outbound_booking_tariff_segments) return false;
      return props.bookingData.outbound_booking_tariff_segments.some(segment => 
        segment.required_products.some(product => product.can_change_seat)
      );
    });

    return {
      seatBox,
      bikeBox,
      chevron,
      canChangeSeat,
      bookingNumber: props.bookingNumber,
      t
    }
  },
})
</script>

<style lang="scss" scoped>
  /* .add-on-links {
    list-style-type: none;
    padding: 1rem;
    margin: 0;

    li:not(:first-child) {
      border-top: 1px solid $clr-primary-100;
    }

    &__upgrade-link {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: rem(12);
      margin-bottom: rem(12);
      padding: rem(4) 8px rem(4) 4px;
      border-radius: 4px;
      text-decoration: none;
      color: $clr-primary-800;

      &:hover {
        background-color: $clr-primary-50;
      }

      span {
        display: flex;
        align-items: center;
      }
    }

    &__icon-square {
      background-color: $clr-secondary;
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 1rem;
      border-radius: $border-radius-small;
    }

    &__icon-link {
      width: 16px;
      height: 16px;
      color: $clr-white;
    }

    &__chevron {
      transform: rotate(90deg);
      width: 16px;
      height: 16px;
      color: $clr-gray;
    }
  } */
</style>
